export const CREATE_OFFER_ACTION = '[Offer Action] Create Offer';
export const CONFIRMED_CREATE_OFFER_ACTION = '[Offer Action] Confirmed Create Offer';
export const CREATE_OFFER_ERROR_ACTION='[Offer Action] Create Offer Error';
export const GET_OFFERS = '[Offer Action] Get Offers';
export const CONFIRMED_GET_OFFERS = '[Offer Action] Confirmed Get Offers';
export const LOADING_OFFERS = '[Offer Action] Loading for Offers';
export const EDIT_OFFER_ACTION = '[Offer Action] Edit Offer';
export const CONFIRMED_EDIT_OFFER_ACTION = '[Offer Action] Confirmed Edit Offer';
export const DELETE_OFFER_ACTION = '[Offer Action] Delete Offer';
export const CONFIRMED_DELETE_OFFER_ACTION = '[Offer Action] Confirmed Delete Offer';
export const OFFER_ERROR_ACTION = '[Offer Action] Error';
export const CLEAR_OFFER_ERROR = '[Offer Action] Clear Error';



